<template>
  <section :class="[$options.name]" data-testid="login-page">
    <AccountMenu
      :is-mobile="isMobile"
      :redirection="{ path: '/register', text: translations.register.action }"
      class="tw:mb-10"
    />

    <AccountContent :is-mobile="isMobile" :subtitle="translations.subtitle" :title="translations.title">
      <AccountLoginForm :is-mobile="isMobile" @register="gotoRegister" />
    </AccountContent>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import AccountLoginForm from "../components/Account/AccountLoginForm.vue";
import AccountMenu from "../components/Account/AccountMenu.vue";
import AccountContent from "../components/Account/AccountContent.vue";

export default defineComponent({
  name: "PageLogin",
  components: {
    AccountLoginForm,
    AccountMenu,
    AccountContent,
  },
  setup() {
    const translations = window._trans._account.login;
    const isMobile = ref<boolean>(false);

    function checkIsMobile() {
      isMobile.value = document.documentElement.clientWidth < 992;
    }

    onMounted(() => {
      window.addEventListener("resize", checkIsMobile);
      checkIsMobile();
    });

    function gotoRegister() {
      window.location.href = "/register";
    }

    return {
      gotoRegister,
      isMobile,
      translations,
    };
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account";
</style>
